import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { DrawingBomContext } from "../../DrawingBomContext";
import { modalStyle } from "../../../../../../../../components/modalStyle.js";
import { Button, Typography, Grid } from "@mui/material";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps.js";
import { drawingMaterialsCols } from "../../../Components/cols/drawingsMaterialsCols.js";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SharePointIcon from "../../../../../../../../components/CustomIcons/SharePointIcon.jsx";
import StorageIcon from "@mui/icons-material/Storage";

export default function ComparingModal() {
  const {
    openCompare,
    handleCloseCompareModal,
    comparedDrawing,
    selectedDrawings,
  } = React.useContext(DrawingBomContext);

  // console.log("comparedDrawing", comparedDrawing);
  const states = [
    {
      label: "Deleted",
      state: "deleted",
      color: "red",
      icon: <ClearIcon sx={{ color: "red" }} />,
    },
    {
      label: "New",
      state: "added",
      color: "green",
      icon: <AddCircleIcon sx={{ color: "green" }} />,
    },
    {
      label: "Edited",
      state: "changed",
      // color: "#DC9B50",
      color: "red",
      icon: <EditIcon color="primary" />,
    },
    {
      label: "Unchanged",
      state: "unchanged",
      color: "white",
      icon: <CheckCircleIcon sx={{ color: "#bbb" }} />,
    },
  ];

  const generalTable = {
    columns:
      drawingMaterialsCols(selectedDrawings?.[0]?.materials)
        ?.map((col) => {
          return {
            ...col,
            Cell: ({ row, column }) => {
              const m = row.original;
              // console.log({ m });
              const rowState = m.comparingState;
              const comparingKey = m.comparingKey;
              console.log(comparingKey);
              const cellKey = column.id;
              const cellColor =
                comparingKey === cellKey
                  ? states.find((s) => s.state === rowState).color
                  : "black";

              return (
                <Box
                  sx={{
                    padding: "8px",
                    color:
                      rowState === "added"
                        ? "green"
                        : rowState === "deleted"
                        ? "red"
                        : cellColor,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor:
                      col.accessorKey === comparingKey && "yellow",
                  }}
                >
                  <Box sx={{ display: "inline-block", pr: 1 }}>
                    {cellKey === "markNumber"
                      ? states.find((s) => s.state === rowState)?.icon
                      : ""}{" "}
                  </Box>
                  <Box sx={{ display: "inline-block" }}>
                    {m[col.accessorKey]}
                  </Box>
                </Box>
              );
            },
          };
        })
        .filter((c) => c.accessorKey !== "wt") || [],

    ...lightTable,
    enableStickyHeader: true,
    muiTableContainerProps: { sx: { maxHeight: "500px" } },
  };

  const table1 = useMaterialReactTable({
    data: comparedDrawing?.v1 || [],

    ...generalTable,
  });

  const table2 = useMaterialReactTable({
    data: comparedDrawing?.v2 || [],
    ...generalTable,
  });
  return (
    <div>
      {" "}
      <Modal open={openCompare} onClose={handleCloseCompareModal}>
        <Box sx={{ ...modalStyle, width: "95%", maxHeight: "95%" }}>
          <Box sx={{ display: "inline-block" }}>
            <Typography variant="h5" sx={{ pb: 2 }}>
              Compare Drawing changes :
            </Typography>
            <Grid container sx={{ width: 500 }}>
              <Grid item xs={6}>
                <Typography variant="h7" sx={{}}>
                  Drawing Name :{" "}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {comparedDrawing?.name}
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="h7" sx={{}}>
                  Drawing Sheet :{" "}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {comparedDrawing?.sheetNumber}
              </Grid>
            </Grid>
            {/* <Grid container sx={{ my: 1 }}>
              <Grid item xs={6}>
                <Typography variant="h7" sx={{ lineHeight: 2 }}>
                  Drawing Selected Revisions :{" "}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {comparedDrawing?.revs?.map((rev) => {
                  return <Chip key={rev} label={rev} sx={{ mx: 0.3 }} />;
                })}
              </Grid>
            </Grid> */}
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              mt: -3,
              mb: 1,
            }}
          >
            {states.map((s) => {
              return (
                <Box
                  sx={{ display: "flex", alignItems: "center", mx: 1.5 }}
                  key={s.state}
                >
                  <span style={{ marginRight: "7px" }}>{s.icon}</span>
                  {"     "} {s.label}
                </Box>
              );
            })}
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography
                variant="h7"
                sx={{ textAlign: "center", lineHeight: 2.5 }}
              >
                Source:{" "}
                {selectedDrawings?.[0]?.selectedSource === "sharepoint" ? (
                  <SharePointIcon
                    size={25}
                    sx={{ transform: "translateY(6px)" }}
                  />
                ) : (
                  <StorageIcon
                    sx={{ color: "blue", transform: "translateY(6px)" }}
                  />
                )}
                {"   ("}
                Rev- {comparedDrawing?.revs?.[0]}
                {")"}
              </Typography>

              <MaterialReactTable table={table1} />
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="h7"
                sx={{ textAlign: "center", lineHeight: 2.5 }}
              >
                Source:{" "}
                {selectedDrawings?.[1]?.selectedSource === "sharepoint" ? (
                  <SharePointIcon
                    size={23}
                    sx={{
                      transform: "translateY(6px)",
                      display: "inline-block",
                    }}
                  />
                ) : (
                  <StorageIcon
                    sx={{ color: "blue", transform: "translateY(6px)" }}
                  />
                )}
                {"   ("}
                Rev- {comparedDrawing?.revs?.[1]}
                {")"}
              </Typography>
              <MaterialReactTable table={table2} />
            </Grid>
          </Grid>

          <Box sx={{ textAlign: "right", pt: 1 }}>
            <Button variant="contained" onClick={handleCloseCompareModal}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
